var alertHistoryList = {
	caption: "Liste de l'Historique des Alertes",
	actions: "Actions",
	noResultsMessage: "Aucun résultat trouvé",
	alert: {
		date: "Date alerte",
		time: "Time",
		trigger: "Prix alerte",
		limitType: "Limit type",
		limitAbove: "Upper limit",
		limitBelow: "Lower limit"
	},
	security: {
		name: "Libellé",
		isin: "ISIN",
		lastPrice: "Dernier prix",
		lastPriceDateTime: "Date/Heure",
		assetClass: "Catégorie d'actif",
		exchange: "Marché/bourse"
	}
};
var fr = {
	alertHistoryList: alertHistoryList
};

export { alertHistoryList, fr as default };
